<template>
  <div class="page-container content-430">
    <div>
      <!-- 头部搜索框 start  -->
      <div class="header-wrapper-430">
        <SearchBlock
          ref="searchBlockRef"
          :prop-school-id="schoolId"
          :can-operate-data="canOperateData"
          :course-schedul-list-search="true"
          @getSearchValue="handleGetSearchValue"
        ></SearchBlock>
      </div>
      <!-- 头部搜索框 end  -->
      <!-- 课班列表表格部分 start  -->
      <div
        class="table-main"
        :style="{
          height: pageTableHeight + 'px'
        }"
        style="overflow-y: scroll"
      >
        <div class="table-tip-box">
          <div class="left-wrap">
            <CourseConflictComp
              :item="{
                conflictStatus: 0,
                classroomName: '时间、师资无冲突'
              }"
            ></CourseConflictComp>
            <CourseConflictComp
              :item="{
                conflictStatus: 1,
                classroomName: '时间、师资冲突'
              }"
            ></CourseConflictComp>
            <Checkbox v-model="isShowHostingCourse">同步显示托管课程</Checkbox>
          </div>
          <div
            v-if="conflictOrgListNum && portOrg != 1"
            class="right-wrap"
            @click="handleConflictModal"
          >
            {{ conflictOrgListNum }}所学校排课存在冲突 >>
          </div>
        </div>
        <div class="table-wrapper">
          <div class="title">开展课程</div>
          <div class="table-box">
            <Table
              ref="dataTable"
              border
              :no-data-text="noDataText"
              :columns="renderColumn"
              :data="renderOpenListData"
              :span-method="handleSpan"
              :loading="loading"
            >
              <template slot="time" slot-scope="{ row }">
                <div v-if="row.courseTypeAttr === 2" class="trusteeship-label">
                  托管
                </div>
                <div class="table-padding">{{ row.time }}</div>
              </template>
              <template slot="orgName" slot-scope="{ row }">
                <div class="table-padding">{{ row.orgName }}</div>
              </template>
              <template slot="week-1" slot-scope="{ row }">
                <CourseConflict
                  :list="getWeekData(row.courseList, 1)"
                  :school-id="selectSchoolId"
                  @refresh="handleRefresh"
                ></CourseConflict>
              </template>
              <template slot="week-2" slot-scope="{ row }">
                <CourseConflict
                  :list="getWeekData(row.courseList, 2)"
                  :school-id="selectSchoolId"
                  @refresh="handleRefresh"
                ></CourseConflict>
              </template>
              <template slot="week-3" slot-scope="{ row }">
                <CourseConflict
                  :list="getWeekData(row.courseList, 3)"
                  :school-id="selectSchoolId"
                  @refresh="handleRefresh"
                ></CourseConflict>
              </template>
              <template slot="week-4" slot-scope="{ row }">
                <CourseConflict
                  :list="getWeekData(row.courseList, 4)"
                  :school-id="selectSchoolId"
                  @refresh="handleRefresh"
                ></CourseConflict>
              </template>
              <template slot="week-5" slot-scope="{ row }">
                <CourseConflict
                  :list="getWeekData(row.courseList, 5)"
                  :school-id="selectSchoolId"
                  @refresh="handleRefresh"
                ></CourseConflict>
              </template>
              <template slot="week-6" slot-scope="{ row }">
                <CourseConflict
                  :list="getWeekData(row.courseList, 6)"
                  :school-id="selectSchoolId"
                  @refresh="handleRefresh"
                ></CourseConflict>
              </template>
              <template slot="week-7" slot-scope="{ row }">
                <CourseConflict
                  :list="getWeekData(row.courseList, 7)"
                  :school-id="selectSchoolId"
                  @refresh="handleRefresh"
                ></CourseConflict>
              </template>
            </Table>
            <div v-if="renderOpenListData.length" class="class-room-box">
              <div class="class-room-name">教室数</div>
              <div
                v-for="(classNumItem, index) in classNumArr"
                :key="`${index}-${classNumItem}`"
                class="class-room-num"
              >
                {{ classNumItem }}
              </div>
            </div>
          </div>
        </div>
        <div class="table-wrapper">
          <div class="title">未开展课程</div>
          <div class="table-box">
            <Table
              ref="dataTable"
              border
              :no-data-text="noDataText"
              :columns="renderColumn"
              :data="renderCloseListData"
              :loading="loading"
            >
              <template slot="time" slot-scope="{ row }">
                <div v-if="row.courseTypeAttr === 2" class="trusteeship-label">
                  托管
                </div>
                <div class="table-padding">{{ row.time }}</div>
              </template>
              <template slot="orgName" slot-scope="{ row }">
                <div class="table-padding">{{ row.orgName }}</div>
              </template>
              <template slot="week-1" slot-scope="{ row }">
                <CourseConflict
                  :list="getWeekData(row.courseList, 1)"
                  :type="2"
                  @refresh="handleRefresh"
                ></CourseConflict>
              </template>
              <template slot="week-2" slot-scope="{ row }">
                <CourseConflict
                  :list="getWeekData(row.courseList, 2)"
                  :type="2"
                  @refresh="handleRefresh"
                ></CourseConflict>
              </template>
              <template slot="week-3" slot-scope="{ row }">
                <CourseConflict
                  :list="getWeekData(row.courseList, 3)"
                  :type="2"
                  @refresh="handleRefresh"
                ></CourseConflict>
              </template>
              <template slot="week-4" slot-scope="{ row }">
                <CourseConflict
                  :list="getWeekData(row.courseList, 4)"
                  :type="2"
                  @refresh="handleRefresh"
                ></CourseConflict>
              </template>
              <template slot="week-5" slot-scope="{ row }">
                <CourseConflict
                  :list="getWeekData(row.courseList, 5)"
                  :type="2"
                  @refresh="handleRefresh"
                ></CourseConflict>
              </template>
              <template slot="week-6" slot-scope="{ row }">
                <CourseConflict
                  :list="getWeekData(row.courseList, 6)"
                  :type="2"
                  @refresh="handleRefresh"
                ></CourseConflict>
              </template>
              <template slot="week-7" slot-scope="{ row }">
                <CourseConflict
                  :list="getWeekData(row.courseList, 7)"
                  :type="2"
                  @refresh="handleRefresh"
                ></CourseConflict>
              </template>
            </Table>
          </div>
        </div>
      </div>

      <!-- 课班列表表格部分 end  -->
      <Modal
        v-model="conflictModal"
        title="单位选择"
        footer-hide
        width="800"
        :styles="{ top: '200px' }"
      >
        <ConflictTableModal
          :list="conflictOrgList"
          @change="handleSelectSchool"
        ></ConflictTableModal>
      </Modal>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import SearchBlock from '../assets/components/SearchBlock.vue';
import CourseConflict from './components/CourseConflict.vue';
import CourseConflictComp from './components/CourseConflictComp.vue';
import ConflictTableModal from './components/ConflictTableModal.vue';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import mixinTableHeight from '@/mixins/mixinTableHeight';
import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle';

export default {
  name: 'CcourseSchedulManageCourseSchedulList',
  components: {
    SearchBlock, // 搜索框组件
    CourseConflict,
    CourseConflictComp,
    ConflictTableModal
  },
  mixins: [mixinTableHeight],
  data() {
    return {
      conflictOrgListNum: 0,
      conflictModal: false,
      weekArr: ['week1', 'week2', 'week3', 'week4', 'week5', 'week6', 'week7'],
      // 是否同步显示托管课程
      isShowHostingCourse: false,
      // 课班列表的表头
      renderColumn: [
        slot('时间', 'time', tableColumnsWidth.type3),
        slot('机构名称', 'orgName', tableColumnsWidth.type6),
        slot('周一', 'week-1', tableColumnsWidth.default),
        slot('周二', 'week-2', tableColumnsWidth.default),
        slot('周三', 'week-3', tableColumnsWidth.default),
        slot('周四', 'week-4', tableColumnsWidth.default),
        slot('周五', 'week-5', tableColumnsWidth.default),
        slot('周六', 'week-6', tableColumnsWidth.default),
        slot('周日', 'week-7', tableColumnsWidth.default)
      ],
      openListData: [],
      closeListData: [],
      renderOpenListData: [],
      renderCloseListData: [],
      searchData: {}, // 从搜索框组件拿到的搜索入参
      selectClassRoomId: '', // 选择的某一行的课班id
      selectRelClassRoomId: '', // 选择的某一行的商品id
      selectSchoolId: '', // 选择的某一行的学校id
      portOrg: -1, // 处于哪个端
      conflictOrgList: [],
      conflictOrgListData: [],
      courseList: [],
      classNumArr: [0, 0, 0, 0, 0, 0, 0],
      originalData: {},
      loading: false,
      schoolId: ''

    };
  },
  computed: {
    ...mapState(['userInfo', 'schoolIdForState']),
    ...mapGetters(['routeTitle']),
    // 是否可以操作数据(分端权限)
    canOperateData() {
      // 只有运营端和学校端可以操作数据
      if (this.portOrg === 0 || this.portOrg === 2) {
        return true;
      }
      return false;
    },
    noDataText() {
      if (this.selectSchoolId) {
        return '暂无数据';
      } else {
        return '请选择学校单位';
      }
    },
    pageTableHeight() {
      return this.windowHeight > 970 ? (this.tableHeight - 30) : (this.tableHeight + 30);
    }
  },
  watch: {
    isShowHostingCourse(newVal) {
      this.handleShowData();
    }
  },
  created() {
    this.portOrg = Number(localStorage.getItem('portOrg'));
    // this.getConflictOrgList();
  },
  mounted() {
    // if (this.portOrg === 2) {
    //   this.$refs.searchBlockRef.handleSearch();
    // }
    this.$nextTick(() => {
      // this.schoolId = this.portOrg === 2 ? this.userInfo.orgId : localStorage.getItem('schoolId') ? localStorage.getItem('schoolId') : '';
      this.schoolId = this.portOrg === 2 ? this.userInfo.orgId : this.schoolIdForState ? this.schoolIdForState : '';
    });
    this.$eventHub.$on('changeSchool', id => {
      this.schoolId = id;
    });
  },
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('CcourseSchedulManageCourseSchedulList');
    next();
  },
  activated() {
    this.$eventHub.$on('changeSchool', id => {
      this.schoolId = id;
    });
    this.getCourseScheduleList();
  },
  destroyed() {
    this.$eventHub.$off('changeSchool');
    // window.removeEventListener('resize');
  },
  methods: {
    ...mapMutations(['SET_CACHEROUTE', 'PUSH_CACHEROUTE']),
    // 获取搜索组件传来的搜索入参
    handleGetSearchValue(searchData) {
      const { yearCode, termCode, orgId, courseTypeId } = searchData;
      // if (!schoolId || !yearCode || !termCode) {
      //   this.selectSchoolId = '';
      //   this.$Message.warning('请先选择学校或学期');
      //   return;
      // }
      // this.selectSchoolId = schoolId;
      this.searchData = { schoolId: this.schoolId, yearCode, termCode, orgId, courseTypeId };
      this.getCourseScheduleList();
    },
    handleSpan({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return row.tableSpan;
      }
    },
    // 获取列表信息
    async getCourseScheduleList() {
      const paramsData = Object.assign(this.searchData);
      this.loading = true;
      const res = await courseSchedulCenter.getCourseScheduleListApi(
        paramsData
      );

      this.loading = false;
      if (res.status === 200) {
        this.openListData = this.handleSpanData(res.message.openList, 1);
        this.closeListData = this.handleSpanData(res.message.closeList, 2);
        this.handleShowData();
        this.getConflictOrgList();
      }
    },
    // c处理托管数据
    handleShowData() {
      if (this.isShowHostingCourse) {
        this.renderOpenListData = this.openListData;
        this.renderCloseListData = this.closeListData;
        this.conflictOrgList = this.conflictOrgListData;
        this.conflictOrgListNum = this.originalData.allConflictCount;
        this.courseList = this.courseList;
      } else {
        this.renderOpenListData = this.openListData.filter(
          item => item.courseTypeAttr !== 2
        );
        this.renderCloseListData = this.closeListData.filter(
          item => item.courseTypeAttr !== 2
        );
        this.conflictOrgList = this.conflictOrgListData.filter(
          item => item.courseTypeAttr !== 2
        );
        this.courseList = this.courseList.filter(
          item => item.courseTypeAttr !== 2
        );
        this.conflictOrgListNum = this.originalData.conflictCount;
      }
      this.classNumArr = this.handleClassNum(this.courseList);
    },
    // 处理教室数据
    handleClassNum(list) {
      const classNumArr = [0, 0, 0, 0, 0, 0, 0];
      list.forEach(item => {
        classNumArr[item.weekDate - 1] += item.reqRoomCount;
      });
      return classNumArr;
    },
    // 处理格式化表格数据
    handleSpanData(list, type) {
      const result = [];
      let courseList = [];
      if (!Array.isArray(list) || list.length === 0) {
        return result;
      }
      list.forEach(item => {
        const { courseTypeAttr } = item;
        item.orgList.forEach((orgItem, index) => {
          let tableSpan = [0, 0];
          if (index === 0) {
            tableSpan = [item.orgList.length, 1];
          }
          result.push({
            courseTypeAttr,
            tableSpan,
            ...orgItem
          });
          courseList = [...courseList, ...orgItem.courseList];
        });
      });
      if (type === 1) {
        this.courseList = courseList;
      }
      return result;
    },
    getWeekData(courseList, week) {
      return courseList.filter(item => item.weekDate === week);
    },
    handleConflictModal() {
      this.conflictModal = true;
    },
    // 切换学校
    async handleSelectSchool(data) {
      this.$refs.searchBlockRef.cutSchoolByParent(data);
      this.conflictModal = false;
    },
    // 获取冲突学校
    async getConflictOrgList() {
      if (this.portOrg === 2) {
        return;
      }
      const params = {
        yearCode: this.searchData.yearCode,
        termCode: this.searchData.termCode
      };
      const res = await courseSchedulCenter.getConflictOrgListApi(params);

      if (res.status === 200) {
        this.originalData.allConflictCount = res.message.allConflictCount;
        this.originalData.conflictCount = res.message.conflictCount;
        this.conflictOrgListData = res.message.conflictList;
        this.handleShowData();
      }
    },
    // 重新渲染
    handleRefresh() {
      this.getCourseScheduleList();
    }
  }
};
</script>
<style lang="scss" scoped>
.page-container {
  padding-bottom: 12px;
}
.trusteeship-label {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 20px;
  margin: 0 0 6px 30px;
  background: #ec808d;
  color: #fff;
  border-radius: 6px;
}
.table-padding {
  padding: 8px 18px;
}
.class-room-box {
  display: flex;
  height: 48px;
  border: 1px solid #e8eaec;
  border-top: none;
  .class-room-name {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 300px;
    height: 48px;
  }
  .class-room-num {
    flex: 1;
    flex-shrink: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 48px;
    border-left: 1px solid #e8eaec;
  }
}
/deep/.ivu-table-wrapper {
  overflow: inherit;
}
/deep/.ivu-table-cell {
  padding: 0;
}

.table-tip-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px 0 10px 20px;
  .right-wrap {
    color: #d9001b;
    cursor: pointer;
  }
  .left-wrap {
    display: flex;
    align-items: center;
    > div {
      margin-right: 20px;
    }
  }
}
.table-wrapper {
  display: flex;
  margin: 0 40px 40px 0;
  .title {
    padding: 13px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e8eaec;
    border-right: none;
  }
  .table-box {
    width: 100%;
  }
}
.page-right {
  text-align: right;
  margin-top: 16px;
}
.action-block {
  span {
    color: rgb(41, 113, 235);
  }
  .error {
    color: rgb(255, 92, 92);
  }
  span + span {
    margin-left: 8px;
  }
}
</style>
<style lang="scss">
.time-line-courselist {
  line-height: 24px;
  padding: 8px 0;
}
.table-wrapper .table-box th.ivu-table-column-left {
  padding: 8px 18px;
}
</style>
